export const props = Object.freeze({
  /**
   * URL to POST the preview request to. The endpoint starts the comparison
   * against the canonical source in the background and returns a preview token.
   * @type {String}
   */
  previewUrl: {
    type: String,
    required: true,
  },
  /**
   * URL to GET the preview status from, with the preview token as a `token`
   * query param. Returns the review rows once the comparison is ready.
   * @type {String}
   */
  statusUrl: {
    type: String,
    required: true,
  },
  /**
   * URL to POST the confirmed update to, with the preview token in the body;
   * the server queues the apply.
   * @type {String}
   */
  processUrl: {
    type: String,
    required: true,
  },
  /**
   * Title for the modal.
   * @type {String}
   */
  modalTitle: {
    type: String,
    default: "Update from Canonical",
  },
  /**
   * JSON object of `{new, updated, removed, skipped, unchanged, warning, error}`
   * strings naming the review's row status glyphs, in the icon tooltips and in the
   * legend above the table (server passes localized text). English defaults apply
   * when omitted. An error row's tooltip joins its row errors onto `error`;
   * `warning` names the notice triangle in the Changes column.
   * @type {String}
   */
  statusLabels: {
    type: String,
    default: "",
  },
  /**
   * JSON object of localized UI copy, always passed by the helper. Deep-merged
   * over minimal English defaults in the store. Shape (camelCase keys):
   * `{confirm, cancel, loading, emptyState, noActionableNote, rejectedNote, sourceNote, deferredNote,
   * selectionNote, rejectExcludedLabel, topLevelErrors, removedValue, skippedHeading, noticesHeading, legendHeading,
   * columns: {status, name, type, changes, reason},
   * selection: {selectAll, includeRow, selectedCount},
   * attributes: {<attribute>: <label>, ...},
   * summary: {new, updated, removed, skipped, unchanged, errors},
   * errors: {previewFailed, processFailed}, flash: {queued, viewImport}}`
   * — the summary values are `{one, other}` templates with a literal
   * `%{count}` placeholder; `removedValue` and `selection.includeRow` use `%{name}`,
   * and `selection.selectedCount` uses `%{count}` and `%{total}`. `sourceNote` is
   * rendered above the review table when present; `noticesHeading` heads the table
   * when it holds nothing to apply, and `legendHeading` names its glyph legend;
   * `rejectExcludedLabel` names the per-apply "reject the unchecked rows" toggle, and the
   * note above the table is `deferredNote` while it is off and `selectionNote` while it is on;
   * `flash.viewImport` labels the queued flash's link to the Data Import.
   * @type {String}
   */
  labels: {
    type: String,
    default: "{}",
  },
});
